// extracted by mini-css-extract-plugin
module.exports = {"info":"XML_info__dAK_8","description":"XML_description__2-Foy","edit-btn":"XML_edit-btn__1DK4f","feedInfo":"XML_feedInfo__3a_6_","feedInfoRow":"XML_feedInfoRow__2lkr1"};